<template>
    <main id="main">
        <div class="bg"></div>
        <div class="list_box">
            <!-- <ul class="tabbar">
                <li @click="li_show = 1" :class="li_show === 1 ? 'active' : ''">COVID-19 Articles</li>
                //<li @click="li_show = 2" :class="li_show === 2 ? 'active' : ''">系统评价</li>
                <li @click="li_show = 3" :class="li_show === 3 ? 'active' : ''">Clinical Study Categories</li>
            </ul> -->
            <!-- <ul class="list_li_ul" v-show="li_show === 1">
                <li>
                    <p class="count">共检索到{{ count1 }}条数据</p>
                </li>
                <li>
                    <div class="inline">
                        <span>Category:</span>
                        <label>
                            <select name="COVIDcategory" v-model="linchuangParam.COVIDcategory" @change="selectSearch()">
                                <option value="">请选择</option>
                                <option value="general">General</option>
                                <option value="mechanism">Mechanism</option>
                                <option value="transmission">Transmission</option>
                                <option value="diagnosis">Diagnosis</option>
                                <option value="treatment" selected>Treatment</option>
                                <option value="prevention">Prevention</option>
                                <option value="case report">Case Report</option>
                                <option value="forecasting">Forecasting</option>
                            </select>
                        </label>
                    </div>
                </li>
                <li class="list_li" v-for="(item, index) in list1" v-bind:key="index">
                    <p class="title" @click="getDetail(item.pmid)">{{ index + 1 }},{{ item.title }}</p>
                    <p class="source"><span>作者：</span>{{ item.author }}</p>
                    <p class="source"><span>来源：</span>{{ item.source }}</p>
                    <p class="pmid"><span>PMID：</span>{{ item.pmid }}</p>
                </li>
                <li v-show="btn" class="btn">
                    <button @click="more(3)">查看更多</button>
                </li>
            </ul> -->
            <!-- <ul class="list_li_ul" v-show="li_show === 2">
                <li>
                    <p class="count">共检索到{{ count2 }}条数据</p>
                </li>
                <li class="list_li" v-for="(item, index) in list2" v-bind:key="index">
                    <p class="title" @click="getDetail(item.pmid)">{{ index + 1 }},{{ item.title }}</p>
                    <p class="source"><span>作者：</span>{{ item.author }}</p>
                    <p class="source"><span>来源：</span>{{ item.source }}</p>
                    <p class="pmid"><span>PMID：</span>{{ item.pmid }}</p>
                </li>
                <li v-show="btn" class="btn">
                    <button @click="more(2)">查看更多</button>
                </li>
            </ul> -->

            <!-- <ul class="list_li_ul" v-show="li_show === 3">
                <li>
                    <p class="count">共检索到{{ count3 }}条数据</p>
                </li>
                <li>
                    <div class="inline">
                        <span>Category:</span>
                        <label>
                            <select name="Category" v-model="linchuangParam.category" @change="selectSearch()">
                                <option value="">请选择</option>
                                <option value="therapy" selected>Therapy</option>
                                <option value="clinical prediction guides">Clinical Prediction Guides</option>
                                <option value="diagnosis">Diagnosis</option>
                                <option value="etiology">Etiology</option>
                                <option value="prognosis">Prognosis</option>
                            </select>
                        </label>
                    </div>
                    <div class="inline">
                        <span>Scope:</span>
                        <label>
                            <select name="Scope" v-model="linchuangParam.scope" @change="selectSearch()">
                                <option value="">请选择</option>
                                <option value="Broad">Broad</option>
                                <option value="Narrow">Narrow</option>
                            </select>
                        </label>
                    </div>
                </li>
                <li class="list_li" v-for="(item, index) in list3" v-bind:key="index">
                    <p class="title" @click="getDetail(item.pmid)">{{ index + 1 }},{{ item.title }}</p>
                    <p class="source"><span>作者：</span>{{ item.author }}</p>
                    <p class="source"><span>来源：</span>{{ item.source }}</p>
                    <p class="pmid"><span>PMID：</span>{{ item.pmid }}</p>
                </li>
                <li v-show="btn" class="btn">
                    <button @click="more(1)">查看更多</button>
                </li>
            </ul> -->

            <ul class="list_li_ul">
                <li>
                    <p class="count">共检索到{{ count }}条数据</p>
                </li>
                <li>
                    <div class="inline radioGroup">
                        <span>Category:</span>
                        <van-radio-group v-model="linchuangParam.type" direction="horizontal" @change="radioChangeFun">
                            <van-radio name="1">Clinical Studies</van-radio>
                            <van-radio name="2">COVID-19</van-radio>
                        </van-radio-group>
                    </div>
                    <div class="inline">
                        <span>Filter:</span>
                        <label v-show="linchuangParam.type == 1">
                            <select name="Filter" v-model="linchuangParam.Filter" @change="selectSearch()">
                                <option value="">请选择</option>
                                <option value="therapy" selected>Therapy</option>
                                <option value="clinical prediction guides">Clinical Prediction Guides</option>
                                <option value="diagnosis">Diagnosis</option>
                                <option value="etiology">Etiology</option>
                                <option value="prognosis">Prognosis</option>
                            </select>
                        </label>
                        <label v-show="linchuangParam.type == 2">
                            <select name="Filter" v-model="linchuangParam.Filter" @change="selectSearch()">
                                <option value="">请选择</option>
                                <option value="general">General</option>
                                <option value="mechanism">Mechanism</option>
                                <option value="transmission">Transmission</option>
                                <option value="diagnosis">Diagnosis</option>
                                <option value="treatment" selected>Treatment</option>
                                <option value="prevention">Prevention</option>
                                <option value="case report">Case Report</option>
                                <option value="forecasting">Forecasting</option>
                            </select>
                        </label>
                    </div>
                    <div class="inline" v-show="linchuangParam.type == 1">
                        <span>Scope:</span>
                        <label>
                            <select name="Scope" v-model="linchuangParam.scope" @change="selectSearch()">
                                <option value="">请选择</option>
                                <option value="broad">Broad</option>
                                <option value="narrow">Narrow</option>
                            </select>
                        </label>
                    </div>
                </li>
                <p v-show="listShow" style="text-align:center; margin:5rem auto;color: #888;">暂无数据</p>
                <li class="list_li" v-for="(item, index) in list" v-bind:key="index">
                    <p class="title" @click="getDetail(item.pmid)">{{ index + 1 }},{{ item.title }}</p>
                    <p class="source"><span>作者：</span>{{ item.author }}</p>
                    <p class="source"><span>来源：</span>{{ item.source }}</p>
                    <p class="pmid"><span>PMID：</span>{{ item.pmid }}</p>
                </li>
                <li v-show="count >= 6" class="btn">
                    <button @click="more(1)">查看更多</button>
                </li>
            </ul>

            <div class="loading" v-if="loading">
                <van-loading type="spinner" size="30px" />
            </div>
        </div>
    </main>
</template>
<!--详情https://pm.yuntsg.com/search/get-details?pmid=32447868-->
<script>
import { Dialog } from "vant";

export default {
    name: "lclist",
    components: {
        [Dialog.Component.name]: Dialog.Component
    },
    data() {
        return {
            // active: "",
            // li_show: 1,
            params: {},
            loading: true,
            listShow: false,
            // condition:''
            list: [],
            // list2: [],
            // list3: [],
            count: 0,
            // count2: 0,
            // count3: 0,
            linchuangParam: {},
            keyTerm: ""
        };
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "", iconType: true });
        this.params = this.$route.query;
        this.linchuangParam = this.params;
        this.$post("https://pm.yuntsg.com/cli/search", this.$qs.stringify(this.params)).then((res) => {
            if (res.code === 0) {
                this.loading = false;
                this.list = res.data.data1List;
                // this.list2 = res.data.data2List;
                // this.list3 = res.data.data3List;
                this.count = res.data.data1count;
                // this.count2 = res.data.data2count;
                // this.count3 = res.data.data3count;
                this.keyTerm = res.data.data1seeall;
                this.listShow = res.data.data1List == undefined;
            } else {
                Dialog({ message: res.msg });
            }
        });
    },
    methods: {
        radioChangeFun() {
            if (this.linchuangParam.type == 1) {
                this.linchuangParam.scope = "broad";
                this.linchuangParam.Filter = "therapy";
            }
            if (this.linchuangParam.type == 2) {
                this.linchuangParam.scope = "";
                this.linchuangParam.Filter = "treatment";
            }
            this.selectSearch();
        },
        //详情
        getDetail(pmid) {
            this.$router.push({ path: "/picodetail", query: { pmid } });
        },
        more() {
            // let term = "";
            // switch (num) {
            //     case 1:
            // term = "(" + this.params.key + ")+AND+(" + this.params.Filter + "/" + this.params.scope + "[filter])";
            //         break;
            //     case 2:
            //         term = "(" + this.params.key + ")+AND+(systematic[sb])";
            //         break;
            //     case 3:
            //         term = "(" + this.params.key + ")+AND+(" + this.params.COVIDcategory + "[sb])";
            //         break;
            // }
            this.$router.push({ path: "/pmlist", query: { term: this.keyTerm } });
        },
        selectSearch() {
            this.$post("https://pm.yuntsg.com/cli/search", this.$qs.stringify(this.linchuangParam)).then((res) => {
                if (res.code === 0) {
                    this.loading = false;
                    this.list = res.data.data1List;
                    // this.list2 = res.data.data2List;
                    // this.list3 = res.data.data3List;
                    this.count = res.data.data1count;
                    // this.count2 = res.data.data2count;
                    // this.count3 = res.data.data3count;
                    this.keyTerm = res.data.data1seeall;
                    this.listShow = res.data.data1List == undefined;
                } else {
                    Dialog({ message: res.msg });
                }
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "picodetail") {
            if (!from.meta.isKeepAlive) {
                from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
            }
            next();
        } else {
            from.meta.isKeepAlive = false;
            this.$vnode.parent.componentInstance.cache = {};
            this.$vnode.parent.componentInstance.keys = [];
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    }
};
</script>

<style scoped>
* {
    font-size: 16px;
}

.active {
    border-bottom: 2px solid #3983cf;
}

select {
    background-color: #f7f7f7;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    padding-right: 14px;
}

option {
    height: 100%;
    width: 100%;
    line-height: 40px;
}

.bg {
    height: 12px;
    background-color: #f3f3f3;
}

ul {
    padding: 0;
}

.btn button {
    width: 120px;
    height: 35px;
    font-size: 16px;
    background-color: #3983cf;
    color: white;
    border: none;
    border-radius: 4px;
    margin: 20px auto;
    display: block;
}

.inline {
    margin-top: 10px;
    width: 100%;
    height: auto;
    line-height: 1.5rem;
}

.inline span {
    float: left;
    width: 100px;
    padding: 0 5px;
    text-align: left;
    height: 1.5rem;
    font-size: 16px;
    line-height: 1.5rem;
    display: block;
}

.inline input,
.inline select {
    width: Calc(100% - 100px);
    height: 1.5rem;
    padding-left: 5px;
    font-size: 14px;
    line-height: 1.5rem;
    border: solid 1px #dadada;
    border-radius: 8px;
}

.inline2 input {
    width: 100%;
    margin-left: 0;
}

.inline select {
    background: url("../../assets/img/xiala.png") no-repeat;
    background-size: 0.6rem 0.6rem;
    background-position: 290px 0.4rem;
}

.inline input {
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
}
.radioGroup .van-radio-group {
    height: 1.5rem;
}
.tabbar {
    display: flex;
    width: 100%;
    height: 50px;
    justify-content: space-between;
    line-height: 50px;
    padding-bottom: 1px;
    border-bottom: 1px solid #ededed;
}

.tabbar li {
    width: 50%;
    text-align: center;
    white-space: nowrap;
}

.list_box {
    width: 95%;
    margin: 0 auto;
    display: table;
}

.list_li_ul,
.list_li {
    width: 100%;
    height: auto;
    display: table;
}

.list_li {
    padding: 10px 0;
    border-bottom: 1px solid #e4e4e4;
}

.title {
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 25px;
    color: #1076be;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: normal !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.count {
    margin-top: 10px;
    font-size: 16px;
    line-height: 35px;
}

.source,
.pmid {
    font-size: 16px;
    line-height: 25px;
    color: #989898;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: normal !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.source span,
.pmid span {
    color: black;
}

.loading {
    width: auto;
    margin: 10px auto;
    height: auto;
}

.loading div {
    text-align: center;
}
</style>
